import { WidgetDefinition } from './types';

class WidgetRegistry {
  private widgets = new Map<string, WidgetDefinition>();

  register(definition: WidgetDefinition) {
    this.widgets.set(definition.type, definition);
  }

  getWidget(type: string): WidgetDefinition | undefined {
    return this.widgets.get(type);
  }

  getAllWidgets(): WidgetDefinition[] {
    return Array.from(this.widgets.values());
  }

  getWidgetsBySystem(systemCode?: string): WidgetDefinition[] {
    return Array.from(this.widgets.values()).filter(
      widget => widget.systemCode === systemCode
    );
  }

  getAvailableWidgets(enabledSystems: string[]): WidgetDefinition[] {
    return Array.from(this.widgets.values()).filter(
      widget => !widget.systemCode || enabledSystems.includes(widget.systemCode)
    );
  }
}

export const widgetRegistry = new WidgetRegistry();